import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

/**
 * MaskedLines: splits `text` by lines (either \n or an array) and animates each line
 * from y=110% to y=0 with an overflow-hidden mask.
 */
export function MaskedLines({ lines, className = "", delay = 0, stagger = 0.08, as: Tag = "h1" }) {
    const arr = Array.isArray(lines) ? lines : String(lines).split("\n");
    return (
        <Tag className={className}>
            {arr.map((line, i) => (
                <span
                    key={i}
                    className="block overflow-hidden leading-[0.9] pb-[0.08em]"
                    aria-hidden={i > 0 ? "true" : undefined}
                >
                    <motion.span
                        className="block will-change-transform"
                        initial={{ y: "110%" }}
                        animate={{ y: 0 }}
                        transition={{ duration: 1.05, ease: EASE, delay: delay + i * stagger }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
}

export function FadeUp({ children, delay = 0, y = 24, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.9, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

export function Stagger({ children, className = "", delayChildren = 0, stagger = 0.08 }) {
    return (
        <motion.div
            className={className}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-10% 0px" }}
            variants={{
                hidden: {},
                show: { transition: { delayChildren, staggerChildren: stagger } },
            }}
        >
            {children}
        </motion.div>
    );
}

export const staggerItem = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};
